import Introduction from "@components/vendor/introduction";
import VendorOffer from "@components/shared/vendorOffer";
import OfferQuickStats from "./offerQuickStats";
import { GQLOffers, GQLPosts, GQLCategories } from "@gql/types/gql";
import Info from "./Info";
import Form from "@components/shared/form";
import { AccordionData } from "@genericTypes/sharedTypes";
import ListOfLinks from "@components/shared/listOfLinks";
import { useQuery } from "@tanstack/react-query";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import Head from "next/head";
import Accordion from "@components/shared/newAccordion";
import ListOfContentsMobile from "@components/shared/listOfContentsMobile";
import VendorsSideBySideComparison from "@components/vendorsSideBySideComparison";
import { VendorsToCompare } from "@components/shared/sideWidget";
import style from "./style.module.scss";
import AuthorInfo from "@components/blog/authorInfo";
import { Session } from "src/api/session";
import FormFusion from "@components/shared/formFusion";
export default function Vendor({
    vendor,
    categoryId,
    listOfContentsMobile,
    VendorsToCompare,
    category,
}: {
    vendor?: GQLOffers;
    categoryId: number;
    listOfContentsMobile: { title: string | null; link: string }[];
    VendorsToCompare: VendorsToCompare[];
    category?: GQLCategories | undefined;
}) {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    const session = useQuery<Session>({ queryKey: ["session"] });
    const { data: formFusionForm } = useQuery({
        queryKey: ["formFusionForm"],
    });

    const recentPosts = vendor?.topics as GQLPosts[];
    const FAQs = vendor?.faqs?.map((item) => ({
        id: item?.id as number,
        title: item?.question as string,
        content: item?.answer as string,
    })) as AccordionData[];

    return (
        <>
            {vendor?.score ? (
                <Head>
                    <script
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{
                            __html: `
                        {
                            "@context": "https://schema.org",
                            "@type": "Product",
                            "name":"${(vendor?.name as string) ?? ""}",
                            "description":"${
                                (vendor?.description as string) ?? ""
                            }",
                            "review": {
                                "@type": "Review",
                                "reviewRating": {
                                    "@type": "Rating",
                                    "ratingValue": "${vendor?.score}",
                                    "bestRating": "5"
                                },
                                "author": {
                                    "@type": "Organization",
                                    "name": "Several.com",
                                    "url":"https://${
                                        process.env.NEXT_PUBLIC_DEFAULT_LANG ===
                                        "en"
                                            ? ""
                                            : `${
                                                  process.env
                                                      .NEXT_PUBLIC_DEFAULT_LANG as string
                                              }.`
                                    }several.com"
                                }
                            }
                        }
                    `,
                        }}
                    />
                </Head>
            ) : (
                <></>
            )}

            <section
                className="lg:w-2/3  w-full  lg:px-0 mt-9 lg:mt-0"
                itemScope
                itemType="https://schema.org/Offer"
            >
                <Introduction vendor={vendor as GQLOffers} />
                {listOfContentsMobile?.length > 0 && (
                    <ListOfContentsMobile contents={listOfContentsMobile} />
                )}

                {listOfContentsMobile?.length > 0 && (
                    <ListOfContentsMobile contents={listOfContentsMobile} />
                )}
                {formFusionForm ? (
                    <FormFusion category={category} />
                ) : (
                    <Form shouldSplit />
                )}
                <OfferQuickStats offer={vendor as GQLOffers} />

                <Info vendor={vendor as GQLOffers} />
                <VendorOffer
                    buyer={vendor as GQLOffers}
                    categoryId={categoryId}
                    vendorShow={true}
                />
                {(vendor?.faqs?.length as number) > 0 && (
                    <div className="mt-24" id="faq">
                        <Accordion title="FAQs" data={FAQs} />
                    </div>
                )}
                <div className={`${style["bgStyle"]} lg:hidden   mt-14 `}>
                    <div className="py-10">
                        <div className=" text-xl">
                            <span className="text-[#58616D]">
                                {translate(
                                    translations,
                                    "several_vendor_sideBySideComparison",
                                )}
                            </span>{" "}
                            <span className="font-extrabold italic">
                                {vendor?.name ?? ""}
                            </span>
                        </div>
                        <VendorsSideBySideComparison
                            vendorsToCompare={VendorsToCompare}
                            vendor={vendor as GQLOffers}
                            secondStyle
                        />
                    </div>
                </div>
                {vendor?.writerUser?.nickname && vendor?.writerUser?.bio && (
                    <AuthorInfo
                        withBio
                        mainInfo={vendor}
                        offer
                        category={category?.name as string}
                        region={session.data?.visitDetails?.region ?? ""}
                    />
                )}
                {recentPosts?.length > 0 && (
                    <div className="mt-20">
                        <ListOfLinks
                            title={translate(
                                translations,
                                "several_general_readInOurBlog",
                            )}
                            items={
                                recentPosts as { title: string; link: string }[]
                            }
                        />
                    </div>
                )}
            </section>
        </>
    );
}
